"use strict";
exports.__esModule = true;
var util_1 = require("~/js/lib/util/util");
var STORAGE_NAME = 'downloadGuideConfig';
var DISPLAY_TIMES = 3;
function sameDate(d1, d2) {
    var prev = new Date(d1);
    var now = new Date(d2);
    if (isNaN(+now) || isNaN(+prev)) {
        return false;
    }
    var pYear = prev.getFullYear();
    var pMonth = prev.getMonth();
    var pDate = prev.getDate();
    var nYear = now.getFullYear();
    var nMonth = now.getMonth();
    var nDate = now.getDate();
    return pYear + " " + pMonth + " " + pDate === nYear + " " + nMonth + " " + nDate;
}
var Guider = (function () {
    function Guider() {
        this.data = JSON.parse(util_1.localStorage.getItem(STORAGE_NAME)) || {};
        if (this.data.val === undefined) {
            this.data.val = 0;
        }
    }
    Guider.prototype.display = function () {
        var data = this.data;
        if (!data.time) {
            return true;
        }
        var prev = new Date(data.time);
        if (isNaN(prev.getTime())) {
            return true;
        }
        if (!data.val) {
            return true;
        }
        else {
            var now = new Date();
            if (sameDate(prev, now)) {
                return false;
            }
            else {
                if (!data.val || DISPLAY_TIMES - data.val >= 0) {
                    return true;
                }
            }
            return false;
        }
    };
    Guider.prototype.mark = function () {
        var data = this.data;
        var now = new Date();
        if (data.time && sameDate(data.time, now)) {
            return;
        }
        data.val += 1;
        data.time = +new Date();
        util_1.localStorage.setItem(STORAGE_NAME, JSON.stringify(this.data));
    };
    return Guider;
}());
exports.Guider = Guider;
